<div class="form-step__subheading" data-private>
  {{ user?.firstName }} {{ user?.lastName }}, create your initials below.
</div>

<app-signature-view
  [signature]="signatureData?.svgImageString"
  [imageTypeProvided]="true"
  [placeholderText]="'Your Initials Will Appear Here'"
  [dataTestId]="'drawn-initials-preview'"
  data-private
></app-signature-view>

@if (!!signatureData) {
  <app-button
    class="edit-initials-button"
    type="secondary"
    (buttonClick)="drawInitials()"
    [dataTestId]="'edit-initials-button'"
    >
    Edit</app-button
    >
  } @else {
    <app-button
      class="draw-initials-button"
      type="primary"
      (buttonClick)="drawInitials()"
      [dataTestId]="'draw-initials-button'"
      >
      Draw Your Initials
    </app-button>
  }

  <div [style.visibility]="formStep.errors ? 'visible' : 'hidden'" class="error-message">
    Please draw your initials to continue
  </div>

  <app-button-container>
    <app-button
      [dataTestId]="'previous-button-draw-initials'"
      type="tertiary"
      (buttonClick)="onPreviousClick()"
      >
      Previous
    </app-button>
    <app-button [dataTestId]="'next-button-draw-initials'" type="primary" (click)="nextClick()">
      Next
    </app-button>
  </app-button-container>
